<template>
  <two-sides-modal
    v-model="isDialogOpen"
    title="Cargar Archivo"
    subtitle="Instrucciones"
    icon="mdi-file-document-alert-outline"
    height="auto"
    persistent
    @onClose="resetData"
  >
    <p class="text-center pt-2">
      Estimad@ <span class="font-weight-black">{{ user.name }}</span
      >. Seleccione su archivo con extensión CSV para continuar con la carga
    </p>

    <p class="text-left">
      Cargar archivos donde se escribió el pedido (formato: csv)
    </p>
    <v-form>
      <v-row dense class="mb-4">
        <v-col cols="12" md="6">
          <v-file-input
            ref="inputFile"
            v-model="file"
            label="Archivo CSV"
            accept=".csv"
            outlined
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" md="2" :align="isMobileOrTablet ? 'right' : 'left'">
          <v-btn
            :disabled="loading"
            :loading="loading"
            :block="isMobile"
            class="red-button rounded-lg align-self-end"
            @click="processArchive"
          >
            Cargar
          </v-btn>
        </v-col>
        <v-col cols="12" md="4" align="right">
          <v-btn
            class="white-button font-weight-black"
            :block="isMobile"
            @click="downloadFile"
          >
            Descargar Formato CSV
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <upload-order-by-archive-tabs
      :success-tab-materials="archiveValidatedData?.datos_material || []"
      :error-tab-materials="archiveValidatedData?.datos_error || []"
      :loading="loading"
    />
    <template slot="actions-append">
      <v-btn
        class="green-button"
        :disabled="loading"
        :loading="loading"
        @click="saveValidatedMaterials"
      >
        Cargar al carrito
      </v-btn>
    </template>
  </two-sides-modal>
</template>
<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import TwoSidesModal from '@/components/modals/TwoSidesModal.vue';
  import UploadOrderByArchiveTabs from './UploadOrderByArchiveTabs.vue';
  import screen from '@/mixins/screen';
  import axios from '@/plugins/axios';

  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'UploadOrderByArchive',
    components: {
      TwoSidesModal,
      UploadOrderByArchiveTabs,
    },

    mixins: [screen],
    props: {
      value: {
        type: Boolean,
        default: true,
      },
      order: {
        type: Number,
      },
      customer: {
        type: String,
      },
      doctype: {
        type: String,
      },
    },
    data() {
      return {
        file: null,
        loading: false,
        archiveValidatedData: null,
      };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
      isDialogOpen: {
        set(newVal) {
          this.$emit('input', newVal);
        },
        get() {
          return this.value;
        },
      },
    },
    methods: {
      ...mapActions('ordercart', ['loadCartItems']),
      handleFileUpload(event) {
        this.file = event.target.files[0];
      },
      async processArchive() {
        if (this.file == [] || this.file.length <= 0) {
          this.loading = false;
          this.$toast.warning(
            'Debe seleccionar el archivo CSV para cargar el pedido'
          );

          return;
        }
        const formData = new FormData();
        formData.append('file', this.file);
        try {
          const response = await axios.post('/uploadFile', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          await this.validateArchiveProcessedMaterials(response.data);
        } catch (error) {
          this.$toast.warning(
            'Error al procesar el archivo. Verifique formato.'
          );
        }
      },
      async validateArchiveProcessedMaterials(data) {
        this.loading = true;
        try {
          const response = await axios.post('/getItems', {
            pedido: data,
            customer: this.customer,
            VKORG: this.user.VKORG,
            VTWEG: this.user.VTWEG,
            VKBUR: this.user.VKBUR,
            doctype: this.doctype,
            orderID: this.order,
          });
          this.archiveValidatedData = response.data;
        } catch (error) {
          this.$toast.warning(
            'Error al procesar el archivo. Verifique formato.' + error
          );
        } finally {
          this.loading = false;
        }
      },
      async saveValidatedMaterials() {
        this.loading = true;
        try {
          await axios.post('/save-archive-items', {
            order: this.archiveValidatedData.datos_material,
            doctype: this.doctype,
            orderID: this.order,
            VTWEG: this.user.VTWEG,
          });

          await this.refreshCartMaterials();
        } catch (error) {
          this.$toast.warning(
            'Error al procesar el archivo. Por favor cargar un archivo'
          );
        }
        this.loading = false;
      },
      async refreshCartMaterials() {
        await this.loadCartItems({
          custumer_code: this.customer,
          VKORG: this.user.VKORG,
          VTWEG: this.user.VTWEG,
          VKBUR: this.user.VKBUR,
          doctype: this.doctype,
        });

        this.$emit('materialTotalUpdated');
        this.resetData();
      },
      downloadFile() {
        const url = process.env.VUE_APP_FILES_URL;
        window.open(`${url}/assets/pedidocsv.csv`, '_blank');
      },
      resetData() {
        this.file = null;
        this.archiveValidatedData = null;
        this.isDialogOpen = false;
      },
    },
  };
</script>
